import React from 'react'
import useTrans from '@hooks/useTrans'
import { cn } from '@utils/safeTs'
import { ChevronDown } from '@components/icons'
import styles from './HeaderLabel.module.sass'

interface Props {
  label?: string
  wrappable?: boolean // se la label può andare a capo
  sortable?: boolean
  sortFilter?: 'asc' | 'desc'
  onClick?: () => void
  className?: string
}

const HeaderLabel = (props: Props) => {

  const { 
    label,
    wrappable,
    sortable,
    sortFilter,
    onClick,
    className = '',
  } = props

  const t = useTrans()
  const classNames = cn(styles.root, wrappable && styles['root--wrappable'], sortable && sortFilter ? styles[`root--${sortFilter}`] : undefined, className)

  return sortable ? (
    <button type="button" onClick={onClick} className={classNames}>
      {t(label)}
      {sortable && <ChevronDown aria-hidden />}
    </button>
  ) : (
    <div className={classNames}>
      {t(label)}
    </div>
  )
}

export default HeaderLabel
